import { Component, OnInit } from '@angular/core';
import { ClientesService } from '@modules/clientes/services/clientes.service';
import * as toastr from 'toastr'

@Component({
  selector: 'app-liberar-digitacao-trc',
  templateUrl: './liberar-digitacao-trc.component.html',
  styleUrls: ['./liberar-digitacao-trc.component.css']
})
export class LiberarDigitacaoTrcComponent implements OnInit {

  dtSelecionada = "";

  constructor(
    private clientService: ClientesService,) { }

  ngOnInit() {
  }

  saveAutorizacaoDigitacaoTRC(){
    console.log(this.dtSelecionada, "dtSelecionada");
    

    if(this.dtSelecionada == null && this.dtSelecionada == ""){
      toastr.error('Campo "Data" é obrigatório');
      return;
    }

    let filtro = {
      dt: this.dtSelecionada.toString(),
    }

    this.clientService.saveAutorizacaoDigitacaoTRC(filtro).subscribe(
        resp=> {
                toastr.success("Arquivo gerado!")
              },
        error => {
                toastr.error("Error ao gerar arquivo!")
              }
    )
  }

}
